import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { formCss } from '../css/form';
import { resetCss } from '../css/reset';
import { stackCss } from '../css/stack';
import { typeCss } from '../css/type';
import { wordListPromise } from '../wordList';
import '../wordListElement';
import { Jumble } from './jumble';

// Only lower case letters.
const normalizePattern = (pattern: string) =>
  pattern.toLowerCase().replace(/[^a-z]/g, '');

@customElement('mw-jumble-page')
export class JumblePageElement extends LitElement {
  @state()
  letters = 'wefrlo';
  @state()
  words: string[] = [];

  @state()
  loading = true;

  private readonly jumble = wordListPromise.then(words => new Jumble(words));

  constructor() {
    super();
    this.updateWords();
  }

  onLettersChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.letters = normalizePattern(target.value);
    // A hack? to make sure the input's displayed value updates when the new
    // value undoes the change the user just made. Without this, the framework
    // sees "no change" and the user's change isn't undone.
    // https://github.com/Polymer/lit-element/issues/144#issuecomment-468098257
    target.value = this.letters;
    this.updateWords();
  };

  async updateWords() {
    this.loading = true;
    const jumble = await this.jumble;
    this.words = jumble.matches(this.letters);
    this.loading = false;
  };

  static get styles() {
    return [
      resetCss,
      stackCss,
      typeCss,
      formCss,
    ];
  }

  render() {
    return html`
      <div class="stack">
        <p>
          Enter your jumbled letters to see how to rearrange them into a word.
        </p>

        <div>
          <label for="letters">The jumbled letters</label>
          <input
              id="letters"
              class="puzzle-input"
              autofocus
              spellcheck="false"
              .value="${this.letters}"
              @input="${this.onLettersChange}">
        </div>

        <div>
          <h2>See the ${this.letters.length && this.loading ? '' : this.words.length} unscrambled words</h2>

          ${this.loading ? html`<p>Loading&hellip;</p>` : null}

          ${!this.loading && this.letters.length && this.words.length === 0 ? html`
            <p>
              🤔 We can't find a way to make a word with the letters
              "${this.letters}".
            </p>
            <p>
              Try our Scrabble solver
              "${this.letters}".
            </p>
          ` : null}

          <!--
            With enable2k.txt, the max result size is just 9 words.
            No need for limits.
          -->
          <mw-word-list .words="${this.words}"></mw-word-list>
        </div>
      </div>
    `;
  }
}
